import { jsx as m, jsxs as S } from "react/jsx-runtime";
import W, { useRef as z, useEffect as E } from "react";
import { u as p } from "./index-6a632112.mjs";
import { s as t, a as g, r as C, d as I } from "./themes-5f0b3c3d.mjs";
import { f as j } from "./fontWeights-a25f8f91.mjs";
import { l as x } from "./lineHeights-72d3110c.mjs";
import { useWindowDimensions as A } from "./useWindowDimensions.js";
const L = p.div`
  width: 100%;
  overflow-x: visible;
  overflow-y: hidden;
  padding: 0;
  &&::-webkit-scrollbar {
    display: none;
  }
  scroll-behavior: smooth;
`, q = p.div`
  ${({ $size: e }) => e === "small" ? `
      --svg-wrapper-width: ${t["4x"]};
      --svg-wrapper-height: ${t["4x"]};
      --label-font-size: ${g.xsmall};
      --label-line-height: ${x.small};
    ` : e === "large" ? `
      --svg-wrapper-width: ${t["5x"]};
      --svg-wrapper-height: ${t["5x"]};
      --label-font-size: ${g.medium};
      --label-line-height: ${x.medium};
    ` : `
      --svg-wrapper-width: ${t["5x"]};
      --svg-wrapper-height: ${t["5x"]};
      --label-font-size: ${g.small};
      --label-line-height: ${x.large};
    `}

  position: relative;
  display: inline-flex;
  padding: var(--semantic-spacing-1-x, ${t["1x"]});
  align-items: flex-start;
  gap: var(--semantic-spacing-2-x, ${t["2x"]});
  flex-shrink: 0;
  border-radius: var(--semantic-radius-large, ${C["3x"]});
  box-shadow: 0px 0px 0px 1px inset
    ${({ theme: e }) => e.components.segmentControl.borderColor};
  background: var(
    --semantic-color-fill-primary-subtlest,
    ${({ theme: e }) => e.components.segmentControl.backgroundColor}
  );
  box-sizing: border-box;
  transition: translate 0.5s ease;

  ${({ $variant: e }) => {
  if (e === "fixed")
    return "min-width: 100%;";
}}

  ${({ $size: e }) => e === "small" ? {
  height: t["10x"]
} : e === "large" ? {
  height: t["14x"]
} : {
  height: t["12x"]
}}

  ${({ $variant: e }) => e === "fixed" ? "min-width: 100%;" : ""}

  .item {
    ${({ $variant: e }) => e === "fixed" ? "flex-basis: 100%;" : ""}
    display: flex;
    justify-content: center;
    align-items: center;
    gap: var(--semantic-spacing-2-x, ${t["2x"]});
    box-sizing: border-box;
    border-radius: var(--semantic-radius-medium, ${C["2x"]});

    ${({ $size: e }) => e === "small" ? {
  height: t["8x"],
  padding: `var(--semantic-spacing-1-x, ${t["1x"]}) var(--semantic-spacing-4-x, ${t["4x"]})`
} : e === "large" ? {
  height: t["12x"],
  padding: `var(--semantic-spacing-1-x, ${t["2x"]}) var(--semantic-spacing-4-x, ${t["8x"]})`
} : {
  height: t["10x"],
  padding: `var(--semantic-spacing-1-x, ${t["1x"]}) var(--semantic-spacing-4-x, ${t["6x"]})`
}}

    &:hover {
      background: var(
        --semantic-color-fill-primary-subtle,
        ${({ theme: e }) => e.components.segmentControl.hoverColor}
      );
      cursor: pointer;
    }

    &:focus-visible {
      outline: 2px solid
        ${({ theme: e }) => e.components.segmentControl.focusColor};
      outline-offset: 2px;
    }
  }
`, H = p.div`
  z-index: 5;
  white-space: nowrap;
`, K = p.div`
  position: absolute;
  border-radius: var(--semantic-radius-medium, ${C["2x"]});
  background: var(--semantic-color-action-on-color, #fff);
  z-index: 0;
  left: 0;
  height: 0;
  width: 0;
  transition: left 0.5s ease;
`, O = p.div`
  overflow: hidden;
  color: var(
    --semantic-color-text-primary-strongest,
    ${({ theme: e }) => e.components.segmentControl.textColor}
  );
  text-overflow: ellipsis;

  /* body/medium/S */
  font-family: ${I.body};
  font-size: var(--label-font-size, ${g.small});
  font-style: normal;
  font-weight: ${j.body.regular};
  line-height: var(--label-line-height, ${x.medium});
`, k = p.div`
  ${({ $rightIcon: e }) => e && "margin-left: var(--icon-margin);"};
  ${({ $leftIcon: e }) => e && "margin-right: var(--icon-margin);"};
  width: var(--svg-wrapper-width, ${t["5x"]});
  height: var(--svg-wrapper-height, ${t["5x"]});
  display: flex;
  color: var(
    --semantic-color-text-primary-strongest,
    ${({ theme: e }) => e.components.segmentControl.iconColor}
  );

  svg,
  img {
    width: var(--svg-wrapper-width, ${t["5x"]});
    height: var(--svg-wrapper-height, ${t["5x"]});
  }
`, R = ({
  size: e = "medium",
  variant: l = "fluid",
  className: u,
  children: $,
  onChange: v,
  activeItem: h,
  id: c
}) => {
  const r = z(null), { width: f } = A();
  function b(i, n, o) {
    v?.(i, n);
  }
  return E(() => {
    let i = 0;
    if (r.current) {
      const n = r.current.parentElement, o = r.current.querySelector("#activeIndicator"), a = r.current.querySelectorAll(".item");
      let w = !0, y = 0;
      for (let d = 0; d < a.length; d++)
        w && a[d].attributes.value.value === h && (i = d, y += a[d]?.offsetWidth / 2, w = !1), w && (y += a[d]?.offsetWidth);
      n?.clientWidth && n?.clientWidth < r.current.clientWidth && (r.current.setAttribute(
        "style",
        `translate: calc(${n.clientWidth / 2}px - ${y}px)`
      ), n.scrollLeft = 0);
      const s = { left: 0, top: 0, width: 0, height: 0 };
      s.left = a[i]?.offsetLeft, s.top = a[i]?.offsetTop, s.width = a[i]?.offsetWidth, s.height = a[i]?.offsetHeight, o?.setAttribute(
        "style",
        `left: ${s.left}px; top: ${s.top}px; height: ${s.height}px; width: ${s.width}px`
      );
    }
  }, [h, f, l, e]), /* @__PURE__ */ m(L, { children: /* @__PURE__ */ S(
    q,
    {
      $size: e,
      $variant: l,
      className: u,
      id: c,
      ref: r,
      children: [
        /* @__PURE__ */ m(K, { id: "activeIndicator" }),
        W.Children.map($, (i, n) => W.cloneElement(i, {
          _onChange: b,
          _itemIndex: n
        }))
      ]
    }
  ) });
}, U = ({
  leftIcon: e,
  rightIcon: l,
  label: u,
  ariaLabel: $,
  dataTestId: v,
  className: h,
  value: c,
  _itemIndex: r,
  _onChange: f,
  ...b
}) => {
  function i(o) {
    f?.(o, c, r);
  }
  return /* @__PURE__ */ S(
    H,
    {
      tabIndex: 0,
      onClick: i,
      onKeyUp: (o) => {
        (o.code === "Space" || o.code === "Enter") && f?.(o, c, r);
      },
      className: `item ${h}`,
      "aria-label": $,
      "data-testid": v,
      value: c,
      ...b,
      children: [
        e && !l && /* @__PURE__ */ m(k, { $leftIcon: !0, children: e }),
        /* @__PURE__ */ m(O, { children: u }),
        l && !e && /* @__PURE__ */ m(k, { $rightIcon: !0, children: l })
      ]
    },
    c
  );
};
R.Item = U;
export {
  R as S
};
